// extracted by mini-css-extract-plugin
export default {"titleContainer":"TitleComponent_titleContainer__QsV9U","title":"TitleComponent_title__5YpCU","addButton":"TitleComponent_addButton__vsqTa"};